<style scoped>
.user-inactive {
  color: #c0c0c0;
}
.license-suspended {
  color: #c0c0c0;
  text-decoration: line-through;
}
.user-text {
  max-width: 200px;
}
.text-two-lines {
  display: inline-block;
  overflow: hidden;
  max-height: 3em;
  line-height: 1.5em;
  margin-top: 3px;
  margin-bottom: -3px;
}
.tab-container {
  overflow-y: auto;
  padding-right: 16px;
  padding-bottom: 16px;
  max-height: 70vh;
}
.v-expansion-panels >>> .v-expansion-panel-content {
  padding-right: 0px !important;
  padding-bottom: 0px !important;
}
.v-expansion-panels >>> tbody {
  cursor: pointer;
}
</style>

<template>
  <div>
    <d-expander>
      <template slot="header">
        <v-toolbar-title>Personalverwaltung</v-toolbar-title>
        <v-spacer></v-spacer>
      </template>
      <template>
        <v-tabs
          v-model="tab"
          background-color="blue-grey lighten-5"
          class="fill-height tab-container"
        >
          <v-tab>DRK</v-tab>
          <v-tab>KOOP</v-tab>
          <v-tab>DRK-Assist</v-tab>

          <v-tabs-items
            v-model="tab"
            class="pt-4 blue-grey lighten-5 flex-grow-1"
          >
            <v-tab-item
              v-for="(tab, idx) in tabs"
              :key="idx"
            >
              <v-text-field
                append-icon="search"
                clearable
                single-line
                solo
                flat
                dense
                label="Suchen..."
                v-model="search"
              ></v-text-field>
              <v-card
                flat
                outlined
                class="flex-grow-1"
              >
                <v-toolbar dense flat class="px-3">
                  <v-toolbar-title class="body-1">{{ tab.id === 'assist' ? 'Lizenzen / ' : '' }}Mitarbeiter</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn v-if="canCreate" icon>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon @click.stop="addUser(tab)" v-on="on">person_add</v-icon>
                      </template>
                      <span>{{ tab.id === 'assist' ? 'Lizenz zuordnen' : 'Neuen Nutzer anlegen' }}</span>
                    </v-tooltip>
                  </v-btn>
                  <v-btn v-if="canDelete" icon :disabled="!canBeDeleted">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon @click.stop="deleteUser(tab)" v-on="on">delete</v-icon>
                      </template>
                      <span>{{ tab.id === 'assist' ? 'Gewählte Lizenz freigeben' : 'Gewählte Nutzer löschen' }}</span>
                    </v-tooltip>
                  </v-btn>
                  <v-btn v-if="canActivate && tab.id !== 'assist'" icon :disabled="!canBeActivated">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon @click.stop="enableUser" v-on="on">mdi-eye</v-icon>
                      </template>
                      <span>Gewählte Nutzer aktivieren</span>
                    </v-tooltip>
                  </v-btn>
                  <v-btn v-if="canActivate && tab.id !== 'assist'" icon :disabled="!canBeDisabled">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon @click.stop="disableUser" v-on="on">mdi-eye-off</v-icon>
                      </template>
                      <span>Gewählte Nutzer deaktivieren</span>
                    </v-tooltip>
                  </v-btn>
                </v-toolbar>

                <v-data-table
                  v-if="['drk', 'koop'].indexOf(tab.id) !== -1"
                  single-select
                  v-model="selected"
                  item-key="id"
                  :loading="loading"
                  :items-per-page="15"
                  :search="search"
                  :headers="headers"
                  :items="tab.items"
                  @click:row="checkEmployee"
                >
                  <template v-slot:item.name="{ item }">
                    <span class="text-two-lines" :class="{'user-inactive': !item.active}">{{item.name}}</span>
                  </template>
                  <template v-slot:item.function="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span
                          v-on="on"
                          class="d-inline-block user-text text-two-lines"
                          :class="{'user-inactive': !item.active}"
                        >{{item.function}}</span>
                      </template>
                      <span v-html="item.function.split(', ').join('<br/>')"></span>
                    </v-tooltip>
                  </template>
                </v-data-table>

                <v-data-table
                  v-if="'assist' === tab.id"
                  single-select
                  v-model="selected"
                  item-key="id"
                  group-by="licenseName"
                  show-group-by
                  :loading="loading"
                  :items-per-page="15"
                  :search="search"
                  :headers="headersAssist"
                  :items="tab.items"
                  @click:row="checkEmployee"
                >
                  <template v-slot:group.header="{items, isOpen, toggle}">
                    <th>
                      <v-icon @click="toggle">{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
                      {{ assistGroupHeader(items) }}
                    </th>
                  </template>
                  <template v-slot:item.name="{ item }">
                    <span v-if="!item.suspended" class="text-two-lines" :class="{'user-inactive': !item.active}">{{item.name}}</span>
                    <v-tooltip bottom v-if="item.suspended">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <span class="text-two-lines" :class="{'user-inactive': !item.active, 'license-suspended': item.suspended}">{{item.name}}</span>
                        </span>
                      </template>
                      <span>Diese Lizenz wurde deaktiviert, da die Vertragslaufzeit abgelaufen ist.</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item.licenseName="{ item }">
                    <span>{{item.licenseName}}</span>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </template>
    </d-expander>
    <create-user
      v-model="createDialog"
      :persontype_id="persontype_id"
    ></create-user>
    <AssociateAssistLicense
      v-model="createAssistDialog"
    />
    <confirm-delete-user
      v-model="confirmDeleteDialog"
      :id="selected.length > 0 ? selected[0].id : undefined"
      :name="selected.length > 0 ? selected[0].name : undefined"
    />
    <confirm-delete-assist-assoc
      v-model="confirmAssistDeleteDialog"
      :id="selected.length > 0 ? selected[0].id : 0"
      :name="selected.length > 0 ? selected[0].name : ''"
      :license="selected.length > 0 ? selected[0].licenseName : ''"
      :suspended="selected.length > 0 ? selected[0].suspended : false"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import CreateUser from './CreateUser'
import ConfirmDeleteUser from './ConfirmDeleteUser'
import AssociateAssistLicense from './AssociateAssistLicense.vue'
import ConfirmDeleteAssistAssoc from './ConfirmDeleteAssistAssoc.vue'
import { genericService } from '@/services'

export default {
  name: "UserList",
  components: {
    ConfirmDeleteAssistAssoc,
    AssociateAssistLicense,
    CreateUser,
    ConfirmDeleteUser
  },
  props: {
    currentOrgId: Number
  },
  data () {
    return {
      tab: null,
      persontype_id: 1,
      createDialog: false,
      createAssistDialog: false,
      confirmDeleteDialog: false,
      confirmAssistDeleteDialog: false,
      search: '',
      selected: [],
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Funktion(en)', value: 'function', sortable: false }
      ],
      headersAssist: [
        { text: 'Name', value: 'name', groupable: false },
        { text: 'Lizenz', value: 'licenseName', sortable: false }
      ],
      assistLicenseCountLoaded: false,
      assist: {
        currentLicenses: 0,
        futureLicenses: 0
      }
    }
  },
  computed: {
    ...mapState({
      drkusers: state => state.users.drk,
      koopusers: state => state.users.koop,
      assistusers: state => state.users.assist,
      loading: state => state.users.loading,
      acl: state => state.account.acl
    }),
    ...mapGetters({
      org: 'organisation/fullRec'
    }),
    tabs () {
      return [{
        title: 'DRK',
        id: 'drk',
        persontype_id: 1,
        items: this.drkusers
      }, {
        title: 'KOOP',
        id: 'koop',
        persontype_id: 2,
        items: this.koopusers
      }, {
        title: 'DRK-Assist',
        id: 'assist',
        persontype_id: 1,
        items: this.assistusers
      }];
    },
    canActivate() {
      if (!this.acl) {
        return false;
      }
      return this.acl.user_general_activate;
    },
    canCreate() {
      if (!this.acl) {
        return false;
      }
      return this.acl.user_create;
    },
    canDelete() {
      if (!this.acl) {
        return false;
      }
      return this.acl.user_delete;
    },
    canBeDeleted() {
      return this.selected.length > 0;
    },
    canBeActivated() {
      return this.selected.length > 0 && !this.selected[0].active;
    },
    canBeDisabled() {
      return this.selected.length > 0 && this.selected[0].active;
    }
  },
  asyncComputed: {
    assistLicenseCounts () {
      if (null === this.org) {
        // before even org is loaded
        return new Promise((resolve) => {
            resolve(this.assist)
          }
        )
      }

      // we must not see org mod data
      if (
        !this.assistLicenseCountLoaded &&
        'undefined' === typeof this.org.moduleOptions.value.ProgramDrkassist
      ) {
        genericService.get(`organisations/assistLicenseCount/${this.org.id.value}.json`)
          .then(data => {
            console.log(data)
            this.assistLicenseCountLoaded = true
            this.assist = data
            return data
          })
      }

      // when we have data
      return new Promise((resolve) => {
          resolve(this.assist)
        }
      )
    }
  },
  watch: {
    currentOrgId: {
      immediate: true,
      async handler(id) {
        if (id > 0) {
          await this.getAll({id, type: 'drk'})
          await this.getAll({id, type: 'koop'});
          await this.getAll({id, type: 'assist'})
          if (this.$route.params.user_id !== undefined && this.$route.params.org_id !== undefined) {
            //this.getChecked(Number.isInteger(this.$route.params.user_id) ? this.$route.params.user_id : parseInt(this.$route.params.user_id));
          }
        }
      }
    },
    drkusers(items) {
      if (this.$route.params.user_id !== undefined && this.$route.params.org_id !== undefined) {
        let matchingItem = items.find(i => i.id == this.$route.params.user_id);
        if (matchingItem) {
          this.selected = [matchingItem];
        }
      }
    },
    koopusers(items) {
      if (this.$route.params.user_id !== undefined && this.$route.params.org_id !== undefined) {
        let matchingItem = items.find(i => i.id == this.$route.params.user_id);
        if (matchingItem) {
          this.selected = [matchingItem];
        }
      }
    },
    assistusers(items) {
      if (this.$route.params.user_id !== undefined && this.$route.params.org_id !== undefined) {
        let matchingItem = items.find(i => i.id == this.$route.params.user_id);
        if (matchingItem) {
          this.selected = [matchingItem];
        }
      }
    },
  },
  methods: {
    ...mapActions('users', ['getAll', 'getChecked', 'update']),
    addUser(tab) {
      if (tab.id !== 'assist') {
        this.persontype_id = tab.persontype_id;
        this.createDialog = true;
      }
      if (tab.id === 'assist') {
        this.createAssistDialog = true;
      }
    },
    deleteUser(tab) {
      if (tab.id !== 'assist') {
        this.confirmDeleteDialog = true
      }
      if (tab.id === 'assist') {
        this.confirmAssistDeleteDialog = true
      }
    },
    enableUser() {
      if(this.selected.length > 0) {
        this.update({id: this.selected[0].id, isActive: 1});
      }
    },
    disableUser() {
      if(this.selected.length > 0) {
        this.update({id: this.selected[0].id, isActive: 0});
      }
    },
    checkEmployee(item, data) {
      const org_id = this.currentOrgId.toString()
      if (!data.isSelected) {
        this.selected = [item];
        this.$router.push({ name: 'verzeichnis', params: {org_id: org_id, user_id: item.id} });
      } else {
        this.selected = [];
        this.$router.push({ name: 'verzeichnis', params: {org_id: org_id} });
      }
    },
    assistGroupHeader(items) {
      const item = items[0]
      const lt = item.license
      const itemCount = items.filter(i => i.suspended == 0).length
      const current = this.org.moduleOptions.value.ProgramDrkassist?.currentLicenses ?? this.assistLicenseCounts.currentLicenses
      const future = this.org.moduleOptions.value.ProgramDrkassist?.futureLicenses ?? this.assistLicenseCounts.futureLicenses
      const date = future?.applyBy ?? null
      const remaining = current[lt] - itemCount

      let hint = ''
      if (date != null && future[lt] !== current[lt]) {
        const dir = future[lt] > current[lt] ? 'angehoben' : 'reduziert'
        const [year, month, day] = date.split('-')
        hint = `(${dir} auf ${future[lt]} zum ${day}.${month}.${year})`
      }
      return `${item.licenseName} ${remaining}/${current[lt]} verbleibend ${hint}`
    }
  }
}
</script>
